import { Icon } from '@chakra-ui/react';

export const ThreeDots = (props) => (
  <Icon viewBox="0 0 24 25" boxSize="16px" color="icon.g1" {...props}>
    <circle cx="8" cy="12.3157" r="1" fill="currentColor" />
    <circle cx="12" cy="12.3157" r="1" fill="currentColor" />
    <circle cx="16" cy="12.3157" r="1" fill="currentColor" />
  </Icon>
);
